<template>
  <div style="background: white; padding: 30px">
    <h2>Instructions</h2>
    <p v-if="isMobile" style="margin-bottom: 15px">
      Please drag the success drivers.
    </p>
    <p v-else style="margin-bottom: 15px">
      Please drag the success drivers from the grey box to the green box.
    </p>
    <video :src="videoSrc" autoplay muted loop></video>
    <b-button @click="$parent.close()" type="is-primary">Close</b-button>
  </div>
</template>

<script>
export default {
  computed: {
    isMobile() {
      return window.innerWidth < 769;
    },
    videoSrc() {
      if (this.isMobile) {
        return '/assets/success-driver-ranking-video-mobile.mp4';
      }
      return '/assets/success-driver-ranking-video.mp4';
    },
  },
};
</script>
